import { render } from "./CopyRight.vue?vue&type=template&id=3c4edc41&scoped=true"
import script from "./CopyRight.vue?vue&type=script&lang=js"
export * from "./CopyRight.vue?vue&type=script&lang=js"

import "./CopyRight.vue?vue&type=style&index=0&id=3c4edc41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4edc41"]])

export default __exports__